import { computed } from 'vue';
import { getEmbedType } from '../utils/embed/component-lib.esm2.js';

/**
 * Get the current embed options from a links URL
 */
function useEmbedOptions(_ref) {
  let {
    embedType,
    url
  } = _ref;
  const embedOptions = computed(() => {
    return embedType.value && getEmbedType(url.value);
  });
  const isEmbedLink = computed(() => {
    return !!embedOptions.value;
  });
  const embedId = computed(() => {
    return isEmbedLink.value && embedOptions.value.getId(url.value, embedOptions.value);
  });
  return [isEmbedLink, embedOptions, embedId];
}
export { useEmbedOptions };